import React, { useEffect, useState } from 'react';
import Loader from './LoaderComponent';

interface FullScreenLoaderProps {
    isLoading: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading }) => {

    // Forza il re-render mostrando sempre il loader quando isLoading è true
    if (isLoading) {
        return (
            <div className="fixed inset-0 z-[9999] backdrop-blur-md bg-black/20 flex items-center justify-center">
                <Loader />
            </div>
        );
    }else{
        return null;
    }
};

export default FullScreenLoader;
